export const Accessibility_Custom = 'Custom';
export const Accessibility_Global = 'Global';
export const Accessibility_MeOnly = 'MeOnly';
export const Accessibility_SecurityGroup = 'SecurityGroup';

export const Accessibility_Custom_Name = 'Custom groups';
export const Accessibility_Global_Name = 'Everybody';
export const Accessibility_MeOnly_Name = 'You only';
export const Accessibility_SecurityGroup_Name = 'Your security group and above';

export const accessibility = {
	[Accessibility_Custom]: Accessibility_Custom_Name,
	[Accessibility_Global]: Accessibility_Global_Name,
	[Accessibility_MeOnly]: Accessibility_MeOnly_Name,
	[Accessibility_SecurityGroup]: Accessibility_SecurityGroup_Name,
};

export const accessibilityMatIcon = {
	[Accessibility_Custom]: 'settings_suggest',
	[Accessibility_Global]: 'language',
	[Accessibility_MeOnly]: 'person',
	[Accessibility_SecurityGroup]: 'group',
};
